<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <DiagCorpHeader
      v-if="!isRendering"
      :corpName="corpName"
      :corporateFeatureInfoLabels="corporateFeatureInfoLabels"
      :corporateSelectable="isAdmin"
      :manageCorpName="manageCorpName"
      :isAdmin="isAdmin"
      :isDiagAvailablePlan="isDiagAvailablePlan"
      @select-corporate="emitSelectCorpList"
    ></DiagCorpHeader>
    <DiagHeaderNavigation
      :answeredDiagResultItemsCountTotal="score"
      :diagItemsCountTotal="totalScore"
    ></DiagHeaderNavigation>
    <div class="l-contents">
      <DiagNavigation
        :isAdmin="isAdmin"
      ></DiagNavigation>
      <div class="l-contentsBox">
        <h1 class="l-pageTitle">{{ diagResultSection.diagSection.sortOrder }}. {{ diagResultSection.diagSection.sectionNm }}</h1>
        <DiagAnswerItemInput
          :isIpo="this.isIpo"
          :diagSection="this.diagResultSection.diagSection"
          :urlForms="this.urlForms"
          @change-answer="emitChangeAnswer"
          @show-egov="openEgovModal($event)"
          ref="diagAnswerItemInput"
        ></DiagAnswerItemInput>
        <div class="l-contentsBox__bottom">
          <div class="btn-group">
            <div class="btn-basic is-inlne js-cancel" @click="cancel()">
              <a>キャンセル</a>
            </div>
            <div class="btn-basic is-inlne is-primary js-save" @click="beforeSave()">
              <a>保存</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="l-fixedBar is-top" :class="{ 'is-up' : scrolled }">
      <div>
        <div>
          <p class="title">{{ diagResultSection.diagSection.sectionNm }}</p>
          <div class="answer_number mb-0">
            <div>回答数 {{ answeredItemCount }}/{{ totalCountBySection }} {{ progress }}% <div class="progress_bar"><span :style="'width: ' + progress + '%'"></span></div></div>
          </div>
        </div>
        <div>
          <div class="btn-cancel is-inlne js-cancel" @click="cancel()"><a>キャンセル</a></div>
          <div class="btn-basic is-inlne is-primary js-save" @click="beforeSave()"><a>保存</a></div>
        </div>
      </div>
    </div>
    <transition name="tutorialmodal-fade">
      <DiagFormTutorial
        v-show="isShowTutorial"
        @close-tutorial-modal="save()"
      ></DiagFormTutorial>
    </transition>
    <transition name="egovprovisionmodal-fade">
      <EgovProvisionsModal
        v-if="isShowEgovProvision"
        :itemId="itemId"
        @hide-egov-provision-modal="hideEgovProvision()"
      ></EgovProvisionsModal>
    </transition>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import DiagAnswerItemInput from '@/components/parts/diag/DiagAnswerItemInput.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';
import DiagHeaderNavigation from '@/components/parts/diag/DiagHeaderNavigation.vue';
import DiagNavigation from '@/components/parts/diag/DiagNavigation.vue';
import DiagFormTutorial from '@/components/parts/tutorial/DiagFormTutorial.vue';
import EgovProvisionsModal from '@/components/parts/master/EgovProvisionsModal.vue';

export default {
  components: {
    Loading,
    DiagAnswerItemInput,
    DiagCorpHeader,
    DiagHeaderNavigation,
    DiagNavigation,
    DiagFormTutorial,
    EgovProvisionsModal,
  },
  data() {
    return {
      isProcessing: false,
      isRendering: false,
      diagResultSection: {
        diagSection: {}
      },
      score: 0,
      totalScore: 0,
      scrolled: false,
      answeredItemCount: 0,
      totalCountBySection: 0,
      progress: 0,
      isAnswerChanged: false,
      isAdmin: false,
      isDiagAvailablePlan: false,
      isShowTutorial: false,
      itemId: null,
      isShowEgovProvision: false,
      isIpo: false,
      urlForms: [],
    }
  },
  computed: {
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    sectionId() {
      return this.$store.getters['diag/getSectionId'];
    },
    diagCourseId() {
      return this.$store.getters['diag/getDiagCourseId'];
    },
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    corpName() {
      return this.$store.getters['diag/getCorpName'];
    },
    corporateFeatureInfoLabels() {
      return this.$store.getters['diag/getCorporateFeatureInfoLabels'];
    },
    manageCorpName() {
      return this.$store.getters['auth/getUser'].manageCorpNm;
    },
  },
  watch: {
    async corpId() {
      this.$store.dispatch('diag/setDiagResultId', null);
      this.$router.push({ name: 'diag-top' });
    }
  },
  created: async function() {
    window.addEventListener("scroll", this.handleScroll);
    this.isRendering = true;
    this.isProcessing = true;
    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isAdmin = authority.isAdmin;
    this.isDiagAvailablePlan = authority.isDiagAvailablePlan;
    await this.getAnswerInput(
      this.diagResultId,
      this.sectionId,
      this.diagCourseId,
      this.corpId,
    );
    this.$nextTick(() => {
      this.isRendering = false;
      this.isProcessing = false;

      // NOTE: たぶんレンダリングの最中にtrueに変わってしまっている
      this.isAnswerChanged = false;
    });
  },
  beforeRouteLeave (to, from, next) {
    if (this.isAnswerChanged && !to.query.usertype) {
      const answer = window.confirm("編集中のものは保存されませんが、よろしいですか？")
      next(answer);
    } else {
      next();
    }
  },
  methods: {
    async getAnswerInput(diagResultId, sectionId, diagCourseId, corpId) {
      let res = await this.$axios.post('/ld/api/diag/getDiagAnswerInput', {
        diagResultId: diagResultId,
        sectionId: sectionId,
        diagCourseId: diagCourseId,
        corpId: corpId
      });
      if (res) {
        this.diagResultSection = res.data.diagResultSection;
        this.score = res.data.diagResult.answeredCount;
        this.totalScore = res.data.diagResult.totalCount;
        this.isIpo = res.data.diagResultSection.diagCourse.isIpo;
        this.urlForms = res.data.urlForms;
        // 参考資料は1項目につき1つの欄として扱うため、データがなければ空の1件を用意する
        Object.keys(this.urlForms).forEach((itemId) => {
          if (this.urlForms[itemId].length == 0) {
            this.urlForms[itemId].push({ content: "", viewFlag: false });
          }
        });
      }
    },
    async beforeSave() {
      this.$refs['diagAnswerItemInput'].$v.$touch();
      if (this.$refs['diagAnswerItemInput'].$v.$invalid) {
        this.$toast.error('現状/課題が500字を超えています。保存できませんでした。');
        return;
      }
      this.isShowTutorial = this.$store.getters['auth/getUser'].tutorial.isShowDiagAnswerFormTutorial;
      if (this.isShowTutorial) {
        this.showTutorialModal(this.isShowTutorial);
      } else {
        this.save();
      }
    },
    async save() {
      this.isProcessing = true;
      this.diagResultSection.title = this.$store.getters['diag/getTitle'];

      let res = await this.$axios.post('/ld/api/diag/storeAnswer', {
        corpId: this.corpId,
        diagResultId: this.diagResultId,
        diagResultSection: this.diagResultSection,
        urlForms: this.urlForms,
      });
      if (res.status === 200) {
        this.$toast.info('保存しました。');
        this.$store.dispatch('diag/setDiagResultId', res.data.diagResult.diagResultId);
        this.score = res.data.diagResult.score;
        this.totalScore = res.data.diagResult.totalScore;
        this.$store.dispatch('diag/setDiagRevisionFlg', false);
        this.isAnswerChanged = false;
        this.$router.push({ name: 'diag-section-list' });
      } else {
        this.$toast.error(res.data.message);
      }
      this.isProcessing = false;
    },
    cancel() {
      this.$router.push({ name: 'diag-section-list', query: { diagCourseId: this.diagCourseId } });
    },
    handleScroll() {
      this.scrolled = window.scrollY > 300;
    },
    emitChangeAnswer(param) {
      this.answeredItemCount = param.answeredItemCount;
      this.totalCountBySection = param.totalCountBySection;
      this.progress = param.progress;
      this.isAnswerChanged = true;
    },
    emitSelectCorpList(params) {
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);
    },
    showTutorialModal(value) {
      this.isShowTutorial = value;
    },
    openEgovModal(event) {
      this.itemId = event.itemId;
      this.isShowEgovProvision = true;
    },
    hideEgovProvision() {
      this.itemId = null;
      this.isShowEgovProvision = false;
    },
  },
}

</script>

<style scoped>
.tutorialmodal-fade-enter-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-leave-active {
  transition: all .2s ease;
}
.tutorialmodal-fade-enter {
  transform: translateY(-50px);
  opacity: 0;
}
.tutorialmodal-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}

.egovprovisionmodal-fade-enter-active {
  transition: all .2s ease;
}
.egovprovisionmodal-fade-leave-active {
  transition: all .2s ease;
}
.egovprovisionmodal-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.egovprovisionmodal-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
